import React from 'react';
import Hero from '../components/home/Hero';
import WhySection from '../components/home/WhySection';
import CoursesJunior from '../components/home/CoursesJunior';
import CoursesSenior from '../components/home/CoursesSenior';
import AISection from '../components/home/AISection';
import Methodology from '../components/home/Methodology';
import PortalPreview from '../components/home/PortalPreview';
import ParentsSchools from '../components/home/ParentsSchools';
import Pricing from '../components/home/Pricing';
import Button from '../components/ui/Button';

const Home = () => {
  return (
    <main>
      <Hero />
      <WhySection />
      <CoursesJunior />
      <CoursesSenior />
      <AISection />
      <Methodology />
      <PortalPreview />
      <ParentsSchools />
      
      {/* Testimonials Simplified Inline */}
      <section className="py-20 bg-slate-950 border-t border-slate-900">
        <div className="container mx-auto px-6 text-center">
            <h2 className="text-2xl font-bold text-slate-100 mb-10">What Students Say</h2>
            <div className="grid md:grid-cols-3 gap-8">
               {[
                 { q: "Physics finally feels like a movie I understand.", a: "Class 10 Student" },
                 { q: "My son went from avoiding math to showing me his AI projects.", a: "Parent" },
                 { q: "The portal makes it easy to assign lessons.", a: "Teacher" }
               ].map((t, i) => (
                 <div key={i} className="bg-slate-900 p-6 rounded-xl">
                   <p className="text-slate-300 italic mb-4">"{t.q}"</p>
                   <p className="text-slate-500 text-sm font-bold">- {t.a}</p>
                 </div>
               ))}
            </div>
        </div>
      </section>

      <Pricing />

      {/* Final CTA */}
      <section className="py-24 bg-slate-950 text-center relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-t from-cyan-900/10 to-transparent pointer-events-none" />
        <div className="container mx-auto px-6 relative z-10">
          <h2 className="text-3xl md:text-5xl font-bold text-slate-100 mb-6">Ready to Start the Journey?</h2>
          <p className="text-xl text-slate-400 mb-8">Give your child a visual, AI-ready path from Class 5 to Class 12.</p>
          <div className="flex justify-center gap-4">
            <Button>Enter Course Portal</Button>
            <Button variant="secondary">Book a Demo</Button>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Home;